// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__-RVbZ","reloadButton":"ErrorBoundary_reloadButton__uEC6F"};